var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "130px",
    height: "130px",
    viewBox: "0 0 130 130",
    style: {
      enableBackground: "new 0 0 130 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.Drop_x0020_Shadow{fill:none;}\n\t.Round_x0020_Corners_x0020_2_x0020_pt{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.Live_x0020_Reflect_x0020_X{fill:none;}\n\t.Bevel_x0020_Soft{fill:url(#SVGID_1_);}\n\t.Dusk{fill:#FFFFFF;}\n\t.Foliage_GS{fill:#FFDD00;}\n\t.Pompadour_GS{fill-rule:evenodd;clip-rule:evenodd;fill:#44ADE2;}\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -35,
    y1: -35,
    x2: -34.2928963,
    y2: -34.2928925
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEDFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738151,
    style: {
      stopColor: "#D8D9DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352005,
    style: {
      stopColor: "#C9CACD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322592,
    style: {
      stopColor: "#B4B5B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7138845,
    style: {
      stopColor: "#989A9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8949245,
    style: {
      stopColor: "#797C7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#656B6C"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120.6399994,62.8482513v33.2600021c0,2.5299988-0.3700027,4.9599991-1.0699997,7.2599945H10.4300003 c-0.7000008-2.2999954-1.0700006-4.7299957-1.0700006-7.2599945V62.8482513H120.6399994z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.6399994,50.458252v12.3899994H9.3599997V33.8882523 c0-13.8800011,11.250001-25.1300011,25.1399994-25.1300011h45.1699982l0.0699997,0.0700006 c-0.3899994,2.0900002-0.5899963,4.25-0.5899963,6.4499998c0,19.5699997,15.8600006,35.4399986,35.4399948,35.4399986 c1.9900055,0,3.9300003-0.1599998,5.8300018-0.4799995h0.0100021L120.6399994,50.458252z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7399979,8.8282518l40.6800003,41.4099998c-1.9000015,0.3199997-3.8399963,0.4799995-5.8300018,0.4799995 c-19.5799942,0-35.4399948-15.8699989-35.4399948-35.4399986C79.1500015,13.0782518,79.3499985,10.918252,79.7399979,8.8282518z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.4300003,103.368248h109.1399994C116.4599991,113.7182541,106.8600006,121.2482529,95.5,121.2482529h-61 C23.1399994,121.2482529,13.54,113.7182541,10.4300003,103.368248z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.4199982,50.2382507L79.7399979,8.8282518l-0.0699997-0.0700006H34.5 c-13.8899994,0-25.1399994,11.25-25.1399994,25.1300011v28.9599991v33.2600021 c0,2.5299988,0.3699999,4.9599991,1.0700006,7.2599945C13.54,113.7182541,23.1399994,121.2482529,34.5,121.2482529h61 c11.3600006,0,20.9599991-7.5299988,24.0699997-17.8800049c0.6999969-2.2999954,1.0699997-4.7299957,1.0699997-7.2599945 V62.8482513V50.458252l-0.2099991-0.2200012"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 9.3599997,
    y1: 62.8482513,
    x2: 120.6399994,
    y2: 62.8482513
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 10.4300003,
    y1: 103.368248,
    x2: 119.5699997,
    y2: 103.368248
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.4300003,50.2382507h-0.0100021c-1.9000015,0.3199997-3.8399963,0.4799995-5.8300018,0.4799995 c-19.5799942,0-35.4399948-15.8699989-35.4399948-35.4399986c0-2.1999998,0.1999969-4.3599997,0.5899963-6.4499998 c0-0.0200005,0.0100021-0.04,0.0100021-0.0600004"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.7461548,8.7683048"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.8554688,94.9414062v-3.6201172c2.0527344,0.8955078,4.4790039,1.5673828,7.277832,1.5673828 c3.434082,0,4.8896484-1.4179688,4.8896484-3.7324219c0-2.1269531-0.9331055-2.9482422-3.7324219-3.8066406l-2.4262695-0.671875 c-3.6201172-1.0078125-5.8222656-2.9482422-5.8222656-7.2783203c0-4.3291016,2.7993164-7.2773438,8.5844727-7.2773438 c3.3588867,0,5.1879883,0.6337891,6.605957,1.3808594v3.5830078c-1.6044922-0.671875-3.6948242-1.2695312-6.53125-1.2695312 c-2.6875,0-4.1801758,1.1201172-4.1801758,3.1728516c0,2.015625,0.746582,2.8740234,3.2841797,3.5830078l2.3886719,0.7460938 c4.0307617,1.1572266,6.4570312,2.8369141,6.4570312,7.3896484c0,4.8525391-2.9487305,7.8759766-9.144043,7.8759766 C35.1474609,96.5839844,32.6098633,95.8740234,30.8554688,94.9414062z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.8569336,70.5322266h4.8144531l6.7182617,19.78125h0.1118164l6.6811523-19.78125h4.2919922 l-9.0322266,25.6035156h-4.5532227L50.8569336,70.5322266z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.7919922,83.8564453v-0.7841797c0-9.7412109,5.8974609-12.9501953,12.5410156-12.9501953 c3.2841797,0,5.5234375,0.7089844,7.0166016,1.4921875v3.6582031c-1.5302734-0.671875-3.5087891-1.4189453-6.9052734-1.4189453 c-6.0087891,0-7.7998047,4.03125-7.7998047,8.8457031v1.1572266c0,5.2998047,1.3808594,9.0693359,7.3896484,9.0693359 c1.4931641,0,2.9863281-0.2607422,3.9189453-0.5595703v-5.8222656h-4.7402344v-3.4335938h9.21875v11.8681641 c-1.9404297,0.7841797-4.9267578,1.5673828-8.3603516,1.5673828 C81.5693359,96.5458984,76.7919922,92.8515625,76.7919922,83.8564453z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.72285c15560b7f331d2e5e6094dd5e82.svg";
export { ForwardRef as ReactComponent };